import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ALERT_ACTION } from 'utils/enums';

const initialState: CommonState = {
    loading: false,
    error: undefined,
    alert: { status: false },
};

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading = true;
        },
        hideLoading: (state) => {
            state.loading = false;
        },
        showAlert: (state, action: PayloadAction<IAppAlert>) => {
            state.alert = action.payload;
        },
        hideAlert: (state) => {
            state.alert.status = false;
        },
        alertActionClick: (state, action: PayloadAction<ALERT_ACTION>) => {
            state.alertActionType = action.payload;
        },
        clearAlertAction: (state) => {
            state.alertActionType = undefined;
        },
    },
});

export const {
    showLoading,
    hideLoading,
    showAlert,
    hideAlert,
    alertActionClick,
    clearAlertAction,
} = commonSlice.actions;

export default commonSlice.reducer;
